// The single runtime-owned SYSTEM method shared by every polling trigger of a service; the runtime invokes
// it on each tick and it routes by `invocation.eventName`. Frozen — a published method name.
export const POLLING_SYSTEM_METHOD = 'handleTriggerPollingForEvent'
